// M004-F0764: the caller's OWN system-capability map (GET /users/me/system-permissions),
// for visibility decisions that must never read a role name (M001-D013).
// Fails closed: any failure yields {} so no capability is ever assumed.
import { useEffect, useState } from 'react';
import { userApi } from '../services/api';
import { loadMySystemPermissions } from '../components/admin/userRemovalPolicy';

export default function useMySystemPermissions(enabled = true) {
  const [state, setState] = useState({ permissions: {}, ready: false });
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    loadMySystemPermissions(userApi).then((permissions) => {
      if (!cancelled) setState({ permissions, ready: true });
    });
    return () => { cancelled = true; };
  }, [enabled]);
  return state;
}
